<template>
	<div class="relative" :class="formClass">
		<!-- Enumが配列の場合 -->
		<select
			v-if="selectType == 'array'"
			v-model="model"
			class="select w-full"
			:class="model != '' ? 'active' : ''"
			tabindex="1"
		>
			<option v-if="placeholder" value="" class="placeholder">
				{{ placeholder }}
			</option>
			<option
				v-for="(item, value) in enum"
				:key="item.id"
				:value="item.id"
				:selected="item == modelValue"
			>
				{{ item.name }}
			</option>
		</select>
		<!-- Enumがオブジェクトの場合 -->
		<select
			v-else
			v-model="model"
			class="select w-full"
			tabindex="1"
			:class="model != '' ? 'active' : ''"
		>
			<option v-if="placeholder" value="" class="placeholder">
				{{ placeholder }}
			</option>
			<option
				v-for="(item, value) in enum"
				:key="value"
				:value="value"
				:selected="item == modelValue"
			>
				{{ item }}
			</option>
		</select>
		<i
			v-if="model != ''"
			class="fas fa-solid fa-xmark fa-fw fa-lg footer_icon"
			@click="searchClear"
		/>
	</div>
</template>

<script setup>
import { onMounted } from "vue";

/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["searchClear"]);
/* ---------------------------------------------------------------------------
	絞り込み検索のクリア
---------------------------------------------------------------------------- */
function searchClear() {
	emit("searchClear", props.name);
}
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	enum: [String, Object],
	formClass: [String, Array],
	placeholder: String,
	selectType: String,
	name: String
});
const model = defineModel();

onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.select {
	height: 40px;
	font-size: 1.4rem;
	position: relative;
	@include trans(0.3);
	padding: 10px 22px 6px 6px;
	border-radius: 5px;
	font-weight: normal;
	background-color: $bg-white2;
	border: 1px solid $bg-gray2;
	&:focus {
		@include trans(0.3);
		border-color: $bg-blue2;
		background-color: rgba(0, 104, 179, 0.1);
	}
	&.placeholder {
		color: #d9d9d9;
	}
	&.active {
		transition: unset;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		padding-right: 40px;
	}
}
select:disabled {
	color: $color-gray4;
	opacity: 1 !important;
	background: #eee;
}
.footer_icon {
	cursor: pointer;
	position: absolute;
	top: 21px;
	right: 18px;
	color: $color-gray3;
	@include trans(0.3);
	&:hover {
		color: $color-gray4;
		@include trans(0.3);
	}
}
</style>
